import React from 'react';
import { CheckIcon } from 'lucide-react';
export const TeamsSection = () => {
  const benefits = ['Spot burnout before it spreads.', 'Keep distributed teams engaged and thriving.', 'Replace quarterly surveys with real-time signals.', 'Support teammates exactly when they need it.', 'Zero surveys, zero forms—insight starts day 1.'];
  return <section id="teams" className="py-20 bg-white" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-285">
          Built for Remote & Hybrid Teams
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-286">
          <div data-id="element-287">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center mb-6" data-id="element-288">
                <div className="mr-4 text-[#8679DF]" data-id="element-289">
                  <CheckIcon size={24} data-id="element-290" />
                </div>
                <p className="text-lg text-gray-800" data-id="element-291">{benefit}</p>
              </div>)}
          </div>
          <div className="bg-[#F5F8FF] rounded-xl p-8" data-id="element-292">
            <div className="bg-white rounded-lg p-6 shadow-md mb-6" data-id="element-293">
              <div className="flex items-center mb-4" data-id="element-294">
                <div className="w-[72px] h-[72px] mr-4" data-id="element-295">
                  <svg viewBox="0 0 72 72" fill="none" data-id="element-296">
                    <circle cx="36" cy="36" r="35" fill="white" stroke="#E9E7FD" strokeWidth="2" data-id="element-297" />
                    <g transform="translate(12, 12)" data-id="element-298">
                      <circle cx="24" cy="24" r="23" stroke="white" strokeWidth="2" data-id="element-299" />
                      <path d="M10 48V35C10 28.9249 14.9249 24 21 24H27C33.0751 24 38 28.9249 38 35V48" fill="#14B8A6" data-id="element-300" />
                      <circle cx="24" cy="16" r="10" fill="#8679DF" data-id="element-301" />
                    </g>
                  </svg>
                </div>
                <div data-id="element-302">
                  <h4 className="font-semibold" data-id="element-303">Sarah</h4>
                  <p className="text-sm text-gray-600" data-id="element-304">Product Lead, SaaS</p>
                </div>
              </div>
              <p className="text-gray-700 italic" data-id="element-305">
                "It's like having an executive coach reading the room for you
                24/7."
              </p>
            </div>
            <div className="text-center" data-id="element-306">
              <p className="text-sm text-gray-600 mb-2" data-id="element-307">
                Trusted by remote teams at
              </p>
              <div className="flex justify-center space-x-6" data-id="element-308">
                <div className="text-gray-400 font-semibold" data-id="element-309">Mosdorfer</div>
                <div className="text-gray-400 font-semibold" data-id="element-310">Pransa</div>
                <div className="text-gray-400 font-semibold" data-id="element-311">Initech</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};